import React from 'react';
import styles from '../DiscountOffer.module.css';
import { Typography } from '../../../components/Typography/typography';

const FeatureCard = ({ icon, title, description }) => {
    return (
        <div className={styles.featureCard}>
            <div className={styles.featureIconContainer}>
                <img src={icon} alt={title} className={styles.featureIcon} />
            </div>
            <Typography
                title={title}
                fontSize={18}
                weight="600"
                color="#333"
                textAlignCenter="left"
            />
            <Typography
                title={description}
                fontSize={14}
                color="#666"
                weight="400"
                style={{ textAlign: 'left' }}
            />
        </div>
    );
};

export default FeatureCard; 